import React from 'react';
import { AppContext } from './App';

export function withAppContext () {
  return function (WrappedComponent) {
    function WithAppContext (props) {
      return (
        <AppContext.Consumer>
          { customerDetails =>
            <WrappedComponent {...props} data={customerDetails} />
          }
        </AppContext.Consumer>
      );
    }
    return WithAppContext;
  };
}
